import React from "react";
import { createForm } from "@/components/input/Form";
import { Button } from "@/components";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import toast from "react-hot-toast";
import useContactUs, { initialSendUsAMesage } from "../hooks/useContactUs";

type Props = {
  onSuccess?: () => void;
};

const { withForm, useInitForm, Form, FormInput, FormTextArea } = createForm(initialSendUsAMesage);

function SendUsAMessageForm(_props: Props) {
  useInitForm({ ...initialSendUsAMesage });

  const { executeRecaptcha } = useGoogleReCaptcha();

  const mutator = useContactUs();

  return (
    <Form
      className="mt-4 space-y-4"
      onSubmit={async (payload, { setForm, setErrors }) => {
        if (!executeRecaptcha) {
          toast.error("ReCAPTCHA not available");
          return;
        }
        const gRecaptchaToken = await executeRecaptcha("enquiryFormSubmit");
        try {
          const res = await mutator.mutateAsync({
            payload: { ...payload, recaptcha: gRecaptchaToken }
          });
          setForm({ ...initialSendUsAMesage });
          toast.success(res?.data?.message ?? "Email sent!");
        } catch (error: any) {
          if (error?.response?.status === 422) {
            setErrors(error?.response?.data?.errors);
          }
        }
      }}
    >
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <FormInput name="first_name" label="First Name" placeholder="Enter First Name" />
        <FormInput name="last_name" label="Last Name" placeholder="Enter Last Name" />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <FormInput
          name="email_address"
          label="Email Address"
          type="email"
          placeholder="Enter Email Address"
          transformInput={null}
        />
        <FormInput name="subject" label="Subject" placeholder="Enter Subject" />
      </div>
      <FormTextArea
        name="message"
        label="Message"
        placeholder="Enter message here..."
        textAreaClassName="min-h-[150px]"
      />
      <div className="flex justify-end">
        <Button
          variant="primary"
          type="submit"
          disabled={mutator.isPending}
          className="!rounded-md"
        >
          {mutator.isPending ? "Submitting..." : "Submit Message"}
        </Button>
      </div>
    </Form>
  );
}

export default withForm(SendUsAMessageForm);
